import {useSyncExternalStore} from 'react';

/** ширина `--desktop-large` из guideline.css: с неё лист показывает все экраны сразу */
const WIDE_QUERY = '(min-width: 1100px)';

const subscribe = (onChange: () => void) => {
	const query = window.matchMedia(WIDE_QUERY);
	query.addEventListener('change', onChange);
	return () => query.removeEventListener('change', onChange);
};

/** широкий экран: все экраны листа видны сразу, у кнопок шапки есть подписи */
export const useWideScreen = () =>
	useSyncExternalStore(
		subscribe,
		() => window.matchMedia(WIDE_QUERY).matches,
		() => true,
	);
